import '../scss/pole.scss';

var flexAlign = {
  $parents: $('.js-flex'),
  $headers: $('.js-flex-header'),
  align() {
    this.$headers.css('height', 'auto');
    if($(window).width() <= 992) return;

    this.$parents.each(function () {
      let max = 0;
      let headers = $(this).find('.js-flex-header');
      if (typeof (headers) !== 'undefined' && headers.length !== 0) {
        headers.each(function () {
          let height = $(this).height();
          if (max < height) max = height;
        });
        headers.css('height', max + 'px');
      }
    });
  },
  init() {
    this.align();
    $(window).on('resize', () => { this.align() });
  }
}

$( window ).on('load', () => {
  flexAlign.init();
});